"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import format from "../../formatters/general";
import classNames from "classnames";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
import { isImeKey } from "../../util/ime_key";
export const validId = (id) => {
  return !!id && id !== "";
};
function keyPressNotifier(event, lineItem, action) {
  if (event.key === "Enter" && !isImeKey(event.nativeEvent)) {
    action();
  }
}
function cleanTotal(total) {
  var _a;
  return (_a = format.cleanAmount(total)) != null ? _a : format.cleanAmount(0);
}
function typeWarning(state) {
  if (!validId(state.tms_line_item_type_id)) {
    return /* @__PURE__ */ jsx("small", { className: "error", children: "Please select type" });
  }
}
function possibleActions(props, lineItem) {
  if (!props.readOnly) {
    return /* @__PURE__ */ jsx("div", { className: "small-1 column line-items__actions", children: /* @__PURE__ */ jsx(
      "a",
      {
        onClick: props.removeItem(lineItem),
        className: "line-items__trash",
        title: "Delete item",
        children: /* @__PURE__ */ jsx("i", { className: "fi-trash" })
      }
    ) });
  } else {
    return /* @__PURE__ */ jsx("div", { className: "small-1 column line-items__actions" });
  }
}
function lineItemTypeOptions(props) {
  var _a;
  const empty = { id: "", description: "Select Type" };
  const types = [empty].concat(
    _.sortBy((_a = props.lineItemTypes) != null ? _a : [], "description")
  );
  return types.map((item) => /* @__PURE__ */ jsx("option", { value: item.id, children: item.description }, "item_option_" + item.id));
}
function lineItemFields(props, state) {
  const newState = {
    tms_line_item_type_id: props.lineItem.tms_line_item_type_id,
    description: props.lineItem.description,
    total: format.cleanAmount(props.lineItem.total)
  };
  if (newState.tms_line_item_type_id === state.tms_line_item_type_id && newState.description === state.description && state.editing) {
    newState.total = state.total;
  }
  return newState;
}
class LineItem extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", __spreadProps(__spreadValues({}, lineItemFields(this.props, {})), {
      prevLineItem: this.props.lineItem
    }));
    __publicField(this, "mounted", false);
    __publicField(this, "changeDescription", (lineItem) => {
      return () => {
        this.changeField(this.state.description, "description", lineItem);
      };
    });
    __publicField(this, "changeField", (value, field, lineItem) => {
      this.setState({ updating: true, editing: false });
      this.props.updateItem(lineItem, field, value).then(() => {
        if (this.mounted) this.setState({ updating: false });
      });
    });
    __publicField(this, "changeTypeId", (lineItem) => {
      return (e) => {
        const newId = e.target.value;
        if (this.state.total) {
          lineItem.total = format.cleanAmount(this.state.total);
        }
        if (this.state.description) {
          lineItem.description = this.state.description;
        }
        this.changeField(newId, "tms_line_item_type_id", lineItem);
      };
    });
    __publicField(this, "changeTotal", (lineItem) => {
      return (e) => {
        this.changeField(cleanTotal(this.state.total), "total", lineItem);
      };
    });
    // A drop sets the field's state and reports it in the same tick, before
    // React renders, so these save the dropped value rather than this.state's.
    __publicField(this, "descriptionDropped", (lineItem) => {
      return (description) => {
        this.changeField(description, "description", lineItem);
      };
    });
    __publicField(this, "totalDropped", (lineItem) => {
      return (total) => {
        this.changeField(cleanTotal(total), "total", lineItem);
      };
    });
    __publicField(this, "possibleDescriptionField", (lineItem) => {
      if (this.props.creatingLoad) {
        return /* @__PURE__ */ jsx("div", { className: "small-3 column", children: /* @__PURE__ */ jsx(
          ValueLinkTextDroppableInput,
          {
            type: "text",
            disabled: this.state.updating || this.props.readOnly,
            value: this.state.description,
            onValueChange: (description) => this.setState({ description }),
            onBlur: this.changeDescription(lineItem),
            onKeyDown: _.partial(
              keyPressNotifier,
              _,
              lineItem,
              this.changeDescription()
            ),
            inputDropped: this.descriptionDropped(lineItem),
            placeholder: "description",
            className: "line-item__description"
          }
        ) });
      }
    });
    __publicField(this, "amountField", (lineItem) => {
      const colClass = this.props.creatingLoad ? "small-2" : "small-4";
      return /* @__PURE__ */ jsx("div", { className: "column " + colClass, children: /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
        /* @__PURE__ */ jsx("div", { className: "small-2 columns", children: /* @__PURE__ */ jsx("span", { className: "prefix", children: "$" }) }),
        /* @__PURE__ */ jsx("div", { className: "small-8 columns", children: /* @__PURE__ */ jsx(
          ValueLinkTextDroppableInput,
          {
            type: "text",
            disabled: this.state.updating || this.props.readOnly,
            value: this.state.total,
            onValueChange: (total) => this.setState({ total }),
            onFocus: this.setEditing,
            onBlur: this.changeTotal(lineItem),
            onKeyDown: _.partial(
              keyPressNotifier,
              _,
              lineItem,
              this.changeTotal()
            ),
            inputDropped: this.totalDropped(lineItem),
            placeholder: "amount"
          }
        ) })
      ] }) });
    });
    __publicField(this, "setEditing", () => {
      this.setState({ editing: true });
    });
    __publicField(this, "typeSelector", (lineItem) => {
      const selectClasses = classNames({
        "small-4": this.props.creatingLoad,
        "small-5": !this.props.creatingLoad,
        column: true,
        error: !validId(this.state.tms_line_item_type_id)
      });
      return /* @__PURE__ */ jsxs("div", { className: selectClasses, children: [
        /* @__PURE__ */ jsx(
          "select",
          {
            type: "text",
            value: this.state.tms_line_item_type_id,
            onChange: this.changeTypeId(lineItem),
            disabled: this.state.updating || this.props.readOnly,
            children: lineItemTypeOptions(this.props)
          }
        ),
        typeWarning(this.state)
      ] });
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  // Parents re-render with the same lineItem for unrelated reasons; only a
  // saved or replaced line item should overwrite what's been typed.
  static getDerivedStateFromProps(props, state) {
    if (props.lineItem === state.prevLineItem) return null;
    return __spreadProps(__spreadValues({}, lineItemFields(props, state)), { prevLineItem: props.lineItem });
  }
  render() {
    const lineItem = this.props.lineItem;
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-component": "LineItem",
        className: "small-10 column line-items__line-item",
        children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
          this.typeSelector(lineItem),
          this.possibleDescriptionField(lineItem),
          this.amountField(lineItem),
          possibleActions(this.props, lineItem)
        ] })
      }
    );
  }
}
export default LineItem;
